<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Top Bar/Options-->
				<div class="TopBar">
					<!--Buttons-->
					<div>
						<button class="btn btn-primary" (click)="onRefresh()">Refresh</button>
						<button style="margin-left: 5px" class="btn btn-primary" (click)="onClearPoints()">Clear Points</button>
						<button style="margin-left: 5px" class="btn btn-primary" (click)="onDeselectAll()">Deselect All</button>
						<button [disabled]="CanAdd() == false" style="margin-left: 5px" class="btn btn-primary" (click)="onAdd()">Create Geo Fence</button>
						<button style="margin-left: 5px" class="btn btn-primary" (click)="onDelete()">Delete Geo Fences</button>
						<button style="margin-left: 5px" class="btn btn-primary" (click)="onSearch()">Search</button>

						<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
					</div>

					<!--Info-->
					<div *ngIf="ShowInfo == true" style="margin-top: 10px; margin-bottom: 15px">
						<h4>Top Bar:</h4>
						<div class="InfoBorder">
							<label>Buttons:</label><br />
							<label
								>&#9900; Clear Points: Deletes all the points on the map. Points are used to define new geofences or edit an existing
								geofence</label
							><br />
							<label>&#9900; Deselect All: Deselects all geofences.</label><br />
							<label
								>&#9900; Create Geo Fence: If you have at least 3 points on the map the Create Geo Fence button opens a popup to create a new
								geofence.</label
							><br />
							<label
								>&#9900; Delete Geo Fences: Deletes all the selected geofences. Selected geofences are outline in blue. You can select a
								geofence by clicking on it or using the search menu.</label
							><br />
							<label>&#9900; Search: Opens a menu to search for geofences. This menu lets you edit geofences.</label><br />
							<label>&#9900; Edit: Pressing edit opens up a geofence to edit its shape and information.</label><br />
							<label>&#9900; Save: Pressing save opens a dialog to save and update the geofence you are editing.</label><br />
							<br />
							<label>Overlays (which items/markes to put on the map):</label><br />
							<label
								>&#9900; Show Existing Fences: Shows geofences that are already saved. Hiding existing fences can make it easier to create new
								shapes.</label
							><br />
							<label
								>&#9900; Hide Inactive: Hides inactive geofences. You can activate or deactivate a geofence by pressing edit then save on them
								in the selector and changing the active option in the edit popup.</label
							><br />
							<label
								>&#9900; <span style="color: Red">Hide Unselected</span>: Hides geofences that aren't selected (items are selected by clicking
								on them or searching for them in the selector). <span style="color: Red">NOTE:</span> Nothing will show up if you haven't
								selected any items in the selector</label
							><br />
							<label>&#9900; Show New Points: Shows points you are using to create a new shape.</label><br />
							<label>&#9900; Show Preview: Shows what the shape you are creating or editing will look like based on the selected points.</label
							><br />
							<label>&#9900; New Fence Color: Pick a color for your new geofence (how it displays on the map).</label><br />
							<label>&#9900; New Fence Opacity: Pick how transparent or opaque your new geofence will be on the map.</label><br />
							<br />
						</div>

						<h4>Selector:</h4>
						<div class="InfoBorder">
							<label>&#9900; Selecting a geofence will center the map on it (You may need to zoom in or out).</label><br />
							<label>&#9900; After selecting geofences you can press the button to delete them.</label><br />
							<label>&#9900; Edit lets you edit the shape of a geofence.</label><br />
							<label
								>&#9900; When you are done changing the shape (if you want to change the shape) you can press save to edit the other details of
								the geofence.</label
							><br />
						</div>

						<h4>Map:</h4>
						<div class="InfoBorder">
							<label>Geo Fences:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info</label><br />
							<label>&#9900; Left Click: Selects the geo fence so you can delete it</label><br />
						</div>
					</div>

					<!--Options-->
					<div class="OptionsFlex">
						<div class="OptionsBorder">
							<h5>Overlays:</h5>
							<div class="OverlayGrid">
								<div>
									<label>Geo Fences From Database:</label>

									<div class="OptionsGrid1">
										<label for="ShowExisting">Show Existing Fences:</label>
										<input id="ShowExisting" type="checkbox" [(ngModel)]="ShowExisting" (ngModelChange)="onShowExistingChange($event)" />

										<label for="HideInactive">Hide Inactive:</label>
										<input id="HideInactive" type="checkbox" [(ngModel)]="HideInactive" (ngModelChange)="onHideInactiveChange($event)" />

										<label style="color: Red" for="HideUnselected">Hide Unselected:</label>
										<input
											id="HideUnselected"
											type="checkbox"
											[(ngModel)]="HideUnselected"
											(ngModelChange)="onHideUnselectedChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>New Geo Fence:</label>

									<div class="OptionsGrid1" *ngIf="AdvancedMode == false">
										<label for="ShowNewPoints">Show New Points:</label>
										<input id="ShowNewPoints" type="checkbox" [(ngModel)]="ShowNewPoints" (ngModelChange)="onShowNewPointsChange($event)" />

										<label for="ShowPreview">Show Preview:</label>
										<input id="ShowPreview" type="checkbox" [(ngModel)]="ShowPreview" (ngModelChange)="onShowPreviewChange($event)" />

										<label [style.color]="NewFenceColor">New Fence Color:</label>
										<div>
											<p-colorPicker
												[(ngModel)]="NewFenceColor"
												(ngModelChange)="onNewFenceColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button class="btn btn-primary ResetButton" style="margin-left: 5px" (click)="onResetNewFenceColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>

										<label>New GeoFence Opacity:</label>
										<div class="OpacityGrid">
											<input
												type="range"
												min="0"
												max="1"
												step="0.01"
												[(ngModel)]="NewOpacity"
												(ngModelChange)="onNewOpacityChange($event)"
											/>
											<button class="btn btn-primary ResetButton" (click)="onResetNewOpacity()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>

									<div class="OptionsGrid2" *ngIf="AdvancedMode == true">
										<label for="ShowNewPoints">Show New Points:</label>
										<input id="ShowNewPoints" type="checkbox" [(ngModel)]="ShowNewPoints" (ngModelChange)="onShowNewPointsChange($event)" />

										<label [style.color]="NewFenceColor">New Fence Color:</label>
										<div>
											<p-colorPicker
												[(ngModel)]="NewFenceColor"
												(ngModelChange)="onNewFenceColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button class="btn btn-primary ResetButton" style="margin-left: 5px" (click)="onResetNewFenceColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>

										<label for="ShowPreview">Show Preview:</label>
										<input id="ShowPreview" type="checkbox" [(ngModel)]="ShowPreview" (ngModelChange)="onShowPreviewChange($event)" />

										<label>New GeoFence Opacity:</label>
										<div class="OpacityGrid">
											<input
												type="range"
												min="0"
												max="1"
												step="0.01"
												[(ngModel)]="NewOpacity"
												(ngModelChange)="onNewOpacityChange($event)"
											/>
											<button class="btn btn-primary ResetButton" (click)="onResetNewOpacity()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>

										<label>Brush Mode:</label>
										<select class="form-control" name="BrushModeID" [(ngModel)]="BrushModeID">
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstBrushMode" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="BrushModeID != 0">Brush Size:</label>
										<div *ngIf="BrushModeID != 0" class="OpacityGrid">
											<input class="form-control" type="number" min="0" step="0.001" [(ngModel)]="BrushSize" />
											<button class="btn btn-primary ResetButton" (click)="onResetBrushSize()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>

										<label *ngIf="BrushModeID != 0">Concavity:</label>
										<div *ngIf="BrushModeID != 0" class="OpacityGrid">
											<input class="form-control" type="number" step="0.001" [(ngModel)]="Concavity" />
											<button class="btn btn-primary ResetButton" (click)="onResetConcavity()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!--Main Section-->
				<div
					[ngClass]="{
						MapGridOneCol: ShowSideBar == false,
						MapGridTwoCol: ShowSideBar == true
					}"
				>
					<!--Map-->
					<div>
						<p-gmap
							*ngIf="ShowMap == true"
							[overlays]="overlays"
							[options]="options"
							[style]="{ width: '100%', height: '625px' }"
							(onMapClick)="handleMapClick($event)"
							(onOverlayClick)="handleOverlayClick($event)"
							(onOverlayDragEnd)="onOverlayDragEnd($event)"
						></p-gmap>
					</div>

					<!--Side Bar-->
					<div *ngIf="ShowSideBar == true">
						<caass-geo-fence-side-bar
							[lstGeoFence]="lstGeoFence"
							(SelectedChanged)="onSelectedChanged($event)"
							(CenterOn)="onCenterOn($event)"
							(EditGeoFence)="onEditGeoFence($event)"
							(SaveGeoFence)="onSaveGeoFence($event)"
						>
						</caass-geo-fence-side-bar>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
